import styled from 'styled-components'
import { tokens } from '../../../assets/tokens'

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const Label = styled.label`
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: ${tokens.color.text.label};
`

export const Preview = styled.img`
  width: 200px;
  height: 200px;
  object-fit: cover;
  border-radius: 50%;
  margin: 0 auto;
  border: 4px solid ${props => props.theme.primary};
  padding: 4px;
`
